import { Component } from '@angular/core';

@Component({
  selector: 'icon-chevrons-left',
  templateUrl: './icon-chevrons-left.component.html',
  styleUrls: ['./icon-chevrons-left.component.scss']
})
export class IconChevronsLeftComponent {
}
